import { ApolloLink } from '@apollo/client';
import { logGQLTelemetry } from './logGQLTelemetry';

// Logs one Success row per completed operation. A response that carries GraphQL errors is skipped: the
// error link logs it, and logging it here too made the Success count include every failed request.
export const createSuccessLoggingLink = () =>
  new ApolloLink((operation, forward) => {
    operation.setContext({
      startTime: performance.now(),
    });

    return forward(operation).map(data => {
      if (!data.errors?.length) {
        logGQLTelemetry({
          name: operation.operationName,
          startTimeMs: operation.getContext().startTime,
          status: 'Success',
        });
      }
      return data;
    });
  });
